import axios from "axios";
import { userActions } from "./_actions";

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_LOGIN_API_BASEURL}/`,
  headers: { "Content-Type": "application/json" },
});

axiosInstance.interceptors.request.use(
  (config) => {
    try {
      if (!config.headers.Authorization) {
        const token = JSON.parse(localStorage.getItem("token"));
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        } else {
          config.headers.Authorization = `ApiKey ${process.env.REACT_APP_DUMMY_API_KEY}`;
        }
      }
      return config;
    } catch (error) {
      console.error("Error in request interceptor:", error);
      return config;
    }
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    try {
      if (
        response.data.errorCode &&
        response.status === 200 &&
        response.data.error === "Please log in"
      ) {
        userActions.logout();
        window.location.reload(true);
      } else {
        return response;
      }
    } catch (error) {
      console.error("Error in response interceptor:", error);
      return Promise.reject(error);
    }
  }
);

export default axiosInstance;



